import { message } from "antd";
import { useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { DeleteJobModal } from "./deleteJobModal";
import Job from "../../../../../../redux/models/job";
import { DeleteIconButton } from "../../../../../../common/components/iconButton/deleteIconButton";

export const DeleteJobButton = ({ clientId, job, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onDelete = async () => {
    try {
      setLoading(true);

      await Job.deleteJob(job.id);

      setOpen(false);
      onSuccess?.();
      message.success("Job deleted successfully");
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DeleteIconButton onClick={() => setOpen(true)} />

      {open && (
        <DeleteJobModal
          job={job}
          open={open}
          loading={loading}
          onCancel={() => setOpen(false)}
          onDelete={onDelete}
        />
      )}
    </>
  );
};
